import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../../context';

const CodeCategorySelector = () => {
    const dispatch = useDispatch();
    const codeCategoryFilter = useSelector(state => state.daylight.codeCategoryFilter);
    const setCodeCategoryFilter = (filter) => dispatch(actions.daylight.setCodeCategoryFilter(filter));
    // TODO: do proper diffing
    const daylightCodeCategories = useSelector(state => state.daylight.daylightCodeCategories, shallowEqual);
    return (
        <th scope="col" className="col col-medium">
            <select
                className="p-1 rounded w-100"
                value={codeCategoryFilter}
                onChange={(e) => setCodeCategoryFilter(e.target.value)}>
                <option value="">All Categories</option>
                <option disabled>Category:</option>
                {/* TODO: make sure c is unique */}
                {daylightCodeCategories?.map((c, x) => (
                    <option key={c} value={c}>
                        {c}
                    </option>
                ))}
            </select>
        </th>
    );
};

export default CodeCategorySelector;
